import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import {
  Body1,
  Body2,
  Caption1,
} from "../../../../assets/styles/Typography";
import { IS_LOGGED_IN,
  AUTODISPLAY_DISPLAY_LIST
 } from "../../../AtomStates";
import { useAtom } from "jotai";
import images from "../../../../assets/styles/Images";
import { BoxWrap } from "../../../../assets/styles/BusinessAnalysisStyle";
import { Button } from "../../../../assets/styles/ButtonStyle";


// 토글 스위치 컴포넌트
const ToggleSwitch = ({ isActive, onChange, disabled = false }) => {
  return (
    <ToggleContainer onClick={() => !disabled && onChange(!isActive)} disabled={disabled}>
      <ToggleSlider isActive={isActive}>
        <ToggleKnob isActive={isActive} />
      </ToggleSlider>
      <ToggleLabel isActive={isActive}>
        {isActive ? "활성화" : "비활성화"}
      </ToggleLabel>
    </ToggleContainer>
  );
};

const OrganismDashboardDisplayList = ({handleEditDisplayPopup, handleShowAddDisplayPopup}) => {

  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  // 콘텐츠 목록 데이터 - isActive 상태 추가
 
  // 토글 상태 변경 핸들러
  const handleToggleChange = (id, newState) => {
    setDisplayList(prev => 
      prev.map(display => 
        display._id === id 
          ? { ...display, isActive: newState }
          : display
      )
    );
  };

  const handleCreateDisplay = () => {
    handleEditDisplayPopup(null)
  };


  return (
    <>
      {displayList.length === 0 ? (
        <BoxWrap NoData style={{ height: "300px" }}>
          <img src={images.ListFillPrimary} alt="" />
          <Body2 color="gray700" align="center !important">
            아직 등록된 디스플레이가 없어요. <br />
            Autodisplay 서비스를 적용할 디스플레이 정보를 입력해주세요 
          </Body2>
          <Button
            Medium
            BlueOutline
            onClick={handleCreateDisplay}
          >
            <Caption1 color="primary">디스플레이 등록</Caption1>
          </Button>
        </BoxWrap>
      ) : (
        <ContentListWrap>
          <Table>
            <colgroup>
              <col width="25%" />
              {/* <col width="15%" />
              <col width="15%" />
              <col width="20%" /> */}
              <col width="25%" />
              <col width="20%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>

            <TableHeader>
              <tr>
                <th>
                  <Body1 color="gray700" align="left">
                  디스플레이 명
                  </Body1>
                </th>
            
                <th>
                  <Body1 color="gray700" align="left">
                 해상도
                  </Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">
                 인치
                  </Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">
                  화면 사이즈(mm)
                  </Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">
                  {/* 화면 사이즈(mm) */}
                  </Body1>
                </th>
              </tr>
            </TableHeader>

            <TableBody>
              {displayList.map((display) => (
                <tr key={display._id}>
                  <td>
                    <Body2 color="gray700" align="left">
                      {display.deviceTitle}
                    </Body2>
                  </td>
                  {/* <td>
                    <Body2 color="gray700" align="center">
                      {content.type}
                    </Body2>
                  </td>
                  <td>
                    <StatusBadge status={content.status}>
                      <Caption1 color={content.status === "활성" ? "white" : "gray600"}>
                        {content.status}
                      </Caption1>
                    </StatusBadge>
                  </td> */}
                  <td>
                    <Body2 color="gray700" align="left">
                      {display.deviceSpec.deviceDPI}
                    </Body2>
                  </td>
                  <td>
                    <Body2 color="gray700" align="left">
                      {display.deviceSpec.deviceInch}
                    </Body2>
                  </td>
                  <td>
                    {/* <ToggleCell>
                      <ToggleSwitch 
                        isActive={display.isActive}
                        onChange={(newState) => handleToggleChange(display._id, newState)}
                      />
                    </ToggleCell> */}
                       <Body2 color="gray700" align="left">
                       {display.deviceSpec.deviceWidthMM} x {display.deviceSpec.deviceHeightMM}
                       </Body2>
                  </td>
             
                    <ActionButtonsCell>
                      <EditButton onClick={() => handleEditDisplayPopup(display._id)}>
                        <EditIcon />
                       <Body2 color="gray700" align="left">편집</Body2>
                      </EditButton>
                    </ActionButtonsCell>
           
                </tr>
              ))}
            </TableBody>
          </Table>
        </ContentListWrap>
      )}
    </>
  );
};

export default OrganismDashboardDisplayList;

const ContentListWrap = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${palette.white};
  // border-radius: 10px;
  overflow: hidden;
  // border: 1px solid ${palette.outlineGray};
`;

const TableHeader = styled.thead`
  background: #EEF2F7;
  
  th {
    padding: 16px 20px;
    border-bottom: 1px solid ${palette.outlineGray};
    
    // &:not(:last-child) {
    //   border-right: 1px solid #D6E0EB;
    // }
  }
`;

const TableBody = styled.tbody`
  tr {
    &:hover {
      background: #F9FAFB;
    }
    border-bottom: 1px solid ${palette.outlineGray};
    // &:not(:last-child) {
    //   border-bottom: 1px solid ${palette.outlineGray};
    // }
  }
  
  td {
    padding: 16px 20px;
    
    // &:not(:last-child) {
    //   border-right: 1px solid #E5E7EB;
    // }
  }
`;

const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: ${props => props.status === "활성" ? palette.primary : "#F3F4F6"};
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;
  
  &:hover {
    background: #F3F4F6;
  }
`;

const ToggleCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const ToggleSlider = styled.div`
  position: relative;
  width: 44px;
  height: 24px;
  background-color: ${props => props.isActive ? '#226FFF' : '#D1D5DB'};
  border-radius: 12px;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: ${props => props.isActive ? '#1E5CE6' : '#B5B9BD'};
  }
`;

const ToggleKnob = styled.div`
  position: absolute;
  top: 2px;
  left: ${props => props.isActive ? '22px' : '2px'};
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ToggleLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.isActive ? '#226FFF' : '#6B7280'};
  white-space: nowrap;
`;

const ActionButtonsCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

const EditButton = styled.button`
  // background: #f7f8fa;
  background: none;
  color: #666666;
  
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: all 0.2s ease;

  // &:hover {
  //   background: #e5e7eb;
  // }
`;


const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9124 4.12883C22.329 3.71227 23.0044 3.71227 23.4209 4.12883L28.7542 9.46216C28.9543 9.6622 29.0667 9.93351 29.0667 10.2164C29.0667 10.4993 28.9543 10.7706 28.7542 10.9707L16.7542 22.9707C16.5542 23.1707 16.2829 23.2831 16 23.2831H10.6667C10.0776 23.2831 9.6 22.8055 9.6 22.2164V16.8831C9.6 16.6002 9.71238 16.3289 9.91242 16.1288L21.9124 4.12883ZM22.6667 6.39157L20.1752 8.88307L24 12.7079L26.4915 10.2164L22.6667 6.39157ZM22.4915 14.2164L18.6667 10.3916L11.7333 17.3249V21.1497H15.5582L22.4915 14.2164ZM6.4 7.01641C6.25272 7.01641 6.13333 7.1358 6.13333 7.28307V26.4831C6.13333 26.6303 6.25272 26.7497 6.4 26.7497H25.6C25.7473 26.7497 25.8667 26.6303 25.8667 26.4831V17.1497C25.8667 16.5606 26.3442 16.0831 26.9333 16.0831C27.5224 16.0831 28 16.5606 28 17.1497V26.4831C28 27.8086 26.9255 28.8831 25.6 28.8831H6.4C5.07452 28.8831 4 27.8086 4 26.4831V7.28307C4 5.95759 5.07452 4.88307 6.4 4.88307H15.7323C16.3214 4.88307 16.799 5.36064 16.799 5.94974C16.799 6.53884 16.3214 7.01641 15.7323 7.01641H6.4Z"
      fill="#8A949E"
    />
  </svg>
);
